import React, { PureComponent } from "react";
import FormTextRow from "./FormTextRow";
import FormDropdown from "./FormDropdown";
import FormDatepicker from "./FormDatepicker";
import Avatar from "./Avatar";
import profileStore from "~/redux/profile/store";
import {
  getQuestions,
  updateProfile,
  updateUserQuestionAnswers,
  saveProfile,
  uploadImage,
  updateEditing,
  updateErrors
} from "~/redux/profile/actions";
import PropTypes from "prop-types";
import { findQuestion } from "~/redux/profile/helpers";
import { validator, getAvatar, formatDate, getValidatedFieldValues } from "./helpers";
import { isEqual, forOwn } from "lodash";
import "./style.scss";

class EditProfile extends PureComponent {

  constructor(props){
    super(props);
    this.state = {saved: false};
  }

  componentDidMount() {
    profileStore.dispatch(getQuestions(this.props.user.userId));
  }

  validationCallback = (validationResponse) => {
    const errorExistedBefore = this.props.errors[validationResponse.key]
    if(validationResponse.error || (errorExistedBefore && !validationResponse.error))
    {
      profileStore.dispatch(
        updateErrors({
          key: validationResponse.key,
          value: validationResponse.error
        })
      );
    }
  }
  updateProp = e => {
    const payload = e.target;
    const { key, value } = validator(payload, this.validationCallback);
    profileStore.dispatch(updateProfile(key, value));
  };

  updateDOB = date => {
    if(date){
      if (!date.hasOwnProperty("target")) {
        date = formatDate(date);
      } else {
        date = date.target;
      }
      const { key, value } = validator(date, this.validationCallback);
      profileStore.dispatch(updateProfile(key, value));
    }
  };

  updateQuestion = e => {
    const { key, value } = validator(e.target, this.validationCallback);
    profileStore.dispatch(updateUserQuestionAnswers(key, value));
  };

  emptyField = key => {
    profileStore.dispatch(updateProfile(key, ""));
  };

  updateEditing = e => {
    profileStore.dispatch(updateEditing(false));
  };

  save = e => {
    const userId  = this.props.user.userId;
    const profile = this.props.profile;
    // const profileValues  = getValidatedFieldValues(profile)
    // let hasErrors = false;

    // forOwn(profileValues, (value, key) => {
    //   const payload = { value, name: key };
    //   const validationResponse = validator(payload, this.validationCallback);
    //   if (validationResponse.error) {
    //     hasErrors = true;
    //   }
    // });

    // if (!hasErrors) {
      profileStore.dispatch(saveProfile(userId, profile)).then(this.saveConfirm);
    // }
  };

  saveConfirm = () => {
    this.setState({saved: true});
    window.setTimeout( () => {
      this.setState({saved: false});
    }, 3000);
  }

  handleUpload = e => {
    const file = e.target.files[0];

    profileStore.dispatch(uploadImage(this.props.user.userId, file));
  };

  render() {
    const { profile, errors, questions, saving, user } = this.props;
    const hasProfile = profile !== {};
    const title = `${hasProfile ? "Edit" : "Create"} Profile`;
    const avatarUrl = getAvatar(user, profile);
    const buttonDisabled = !isEqual(errors, {}) || saving;

    return (
      <div className="editProfileContainer">
        <div className="editProfileHeader">
          <a className="viewProfileBtn" onClick={this.updateEditing}>
            <i className="ion-ios-arrow-back" />
          </a>
          <h1 className="title">{title}</h1>
        </div>
        <div className="rows">
          <div className="columnRows">
            <div className="column1">
              <Avatar
                className="avatar"
                handleUpload={this.handleUpload}
                avatarUrl={avatarUrl}
                hasProfile={hasProfile}
              />
              <div className="form">
                <h2 className="publicProfile">Public Profile</h2>
                <FormTextRow
                  onChange={this.updateProp}
                  onEmptyField={this.emptyField}
                  name="username"
                  value={profile.username || ""}
                  error={errors.username}
                />
                <FormTextRow
                  onChange={this.updateProp}
                  onEmptyField={this.emptyField}
                  name="location"
                  value={profile.location || ""}
                  error={errors.location}
                />
              </div>
            </div>
            <div className="column2">
              <div className="form">
                <h2 className="publicProfile">Private Profile</h2>
                <FormTextRow
                  onChange={this.updateProp}
                  onEmptyField={this.emptyField}
                  name="name"
                  label="First Name"
                  value={profile.name || ""}
                  error={errors.name}
                />
                <FormTextRow
                  onChange={this.updateProp}
                  onEmptyField={this.emptyField}
                  name="lastName"
                  label="Last Name"
                  value={profile.lastName || ""}
                  error={errors.lastName}
                />
                <FormDropdown
                  onChange={this.updateProp}
                  name="gender"
                  label="Gender"
                  list={["FEMALE", "MALE", "OTHER", "PREFER NOT TO SAY"]}
                  value={profile.gender}
                  error={errors.gender}
                />
                <FormDatepicker
                  onChange={this.updateDOB}
                  onEmptyField={this.emptyField}
                  name="DOB"
                  label="Birthday"
                  value={profile.DOB || ""}
                  error={errors.DOB}
                />
                <FormTextRow
                  onChange={this.updateProp}
                  onEmptyField={this.emptyField}
                  name="zipCode"
                  label="Zip Code"
                  value={profile.zipCode ? profile.zipCode.toString() : ""}
                  error={errors.zipCode}
                />
                {questions.map((question, key) => {
                  const q = findQuestion(question.question, profile.questions);
                  return (
                    <FormDropdown
                      key={key}
                      name={question.question}
                      onChange={this.updateQuestion}
                      label={question.question}
                      list={question.answers}
                      value={q.answer}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="btnContainer">
          <button
            disabled={buttonDisabled}
            className="profileSaveBtn"
            onClick={this.save}
          >
            {saving ? "Saving" : "Save"}
          </button>
         { this.state.saved && <p className="save-confirm">Saved!</p>}
        </div>
      </div>
    );
  }
}
EditProfile.propTypes = {
  profile: PropTypes.object,
  errors: PropTypes.array,
  questions: PropTypes.array,
  saving: PropTypes.bool
};

window.profileStore = profileStore;

export default EditProfile;
